import { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureIsAuthenticated } from "@/router/guardians"
import { ensureCurrentPendingEnrollmentIdPresence } from "@/modules/enrollment-new/router/guardians"

export default [
  {
    path: "/enroll/vpc-only/check-insurance",
    name: "flow1-vpc-only:check-insurance",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () =>
      import("@/modules/enrollment-new/pages/flow1-vpc-only/Step1-EnrollmentFlowInsuranceCoverageCheckPage.vue")
  },
  {
    path: "/enroll/vpc-only/vpc-details",
    name: "flow1-vpc-only:vpc-details",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow1-vpc-only/Step2-EnrollmentFlowVPCDetailsPage.vue")
  },
  {
    path: "/enroll/vpc-only/confirm-address",
    name: "flow1-vpc-only:confirm-address",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () =>
      import("@/modules/enrollment-new/pages/flow1-vpc-only/Step3-EnrollmentFlowConfirmAccountDetailsPage.vue")
  },
  {
    path: "/enroll/vpc-only/not-covered/:reason",
    name: "flow1-vpc-only:not-covered",
    props: true,
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow1-vpc-only/Step4-EnrollmentFlowVpcNotCoveredPage.vue")
  },
  {
    path: "/enroll/vpc-only/confirm-enroll",
    name: "flow1-vpc-only:confirm-enroll",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow1-vpc-only/Step5-EnrollmentFlowConfirmEnrollPage.vue")
  }
]
